<template>
	<div v-if="context" class="hidden lg:block">
		<template v-if="options.filterRubriken !== false">
			<nk-title size="lg">Kategorien</nk-title>
			<nk-filter-veranstaltungen-rubriken
				:context="context"
				:options="options"
				class="hidden lg:block"
			/>
			<nk-divider />
		</template>
		<template v-if="options.filterZeitraum !== false">
			<nk-title size="lg">Zeitraum</nk-title>
			<nk-filter-veranstaltungen-datum
				:context="context"
				:options="options"
				class="hidden lg:block"
			/>
		</template>
	</div>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {object} context
 * @prop {boolean} options.filterZeitraum
 * @prop {boolean} options.filterRubriken
 */
export default {
	name: 'NkSidebarFilterVeranstaltungen',

	mixins: [TemplatesDefault],
};
</script>
